import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useDataFetch } from "../../../hooks/useDataFetch";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";

import CurrencyInput from "react-currency-input-field";

const validationSchema = Yup.object().shape({
  discount: Yup.number(),
  late_payment: Yup.boolean(),
  transport_payment_value: Yup.number(),
});

const StudentConfig = ({ id, year }) => {
  const [configId, setConfigId] = useState();
  const { postData, patchData, getData } = useDataFetch();

  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      discount: 0,
      late_payment: false,
      transport_payment_value: 0,
    },
  });

  // Resetear formulario cuando cambia el estudiante
  useEffect(() => {
    setConfigId(undefined);
    reset({ discount: 0, late_payment: false, transport_payment_value: 0 });
  }, [id]);

  const { data: dataconfig } = getData(
    ["student-config", id, year],
    `/student/configuration/${id}?year=${year}`,
    {
      enabled: !!id,
    }
  );

  // Cargar datos cuando llega la configuración
  useEffect(() => {
    if (dataconfig?.data && dataconfig?.data?.length > 0) {
      const config = dataconfig.data[0];
      setConfigId(config.id);
      reset({
        discount: config.discount ?? 0,
        late_payment: config.late_payment ?? false,
        transport_payment_value: config.transport_payment_value ?? 0,
      });
    }
  }, [dataconfig]);

  const { mutate: createConfig } = postData(
    "/student-configurations",
    {},
    {},
    {
      onSuccess: (data) => {
        setConfigId(data?.data?.id);
        toast.success("Se completo la acción correctamente.");
      },
    }
  );

  const { mutate: updateConfig, isLoading: isPostLoading } = patchData(
    "/student-configurations",
    {},
    {
      onSuccess: () => {
        toast.success("Se completo la acción correctamente.");
      },
    }
  );

  const onSubmit = (data) => {
    if (configId) {
      updateConfig({ id: configId, ...data });
    } else {
      createConfig({ student_id: id, year, ...data });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className={`col-md-4 mb-3 `}>
          <label htmlFor="firstName">% de descuento</label>
          <input
            type="number"
            className="form-control"
            {...register("discount")}
            min={0}
            max={100}
          />
        </div>
        <div className={`col-md-4 mb-3 `}>
          <label htmlFor="firstName">Valor del Transporte</label>

          <Controller
            name="transport_payment_value"
            control={control}
            render={({ field }) => (
              <CurrencyInput
                className="form-control"
                decimalsLimit={0}
                decimalSeparator=","
                groupSeparator="."
                value={field.value ?? 0}
                onValueChange={(value) => {
                  field.onChange(value);
                }}
              />
            )}
          />
        </div>

        <div className={`col-md-4 mb-3`}>
          <label htmlFor="firstName">Permitir el Pago sin Interes</label>
          <div className="custom-control custom-checkbox mb-3 checkbox-warning check-xl">
            <Controller
              name="late_payment"
              control={control}
              render={({ field }) => (
                <div>
                  <input
                    id="late_payment"
                    checked={field.value}
                    type="checkbox"
                    className="custom-control-input"
                    onChange={() => {
                      console.log("hola", field.value);
                      field.onChange(!field.value);
                    }}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="late_payment"
                  ></label>
                </div>
              )}
            />
          </div>
        </div>
      </div>

      <hr className="mb-4" />
      <div className="d-flex gap-2">
        <button
          className="btn btn-primary btn-lg btn-block"
          type="submit"
          disabled={isPostLoading}
        >
          Guardar
        </button>
        <button
          className="btn btn-danger btn-lg btn-block"
          type="button"
          disabled={isPostLoading}
          onClick={() => {
            if (!window.confirm("¿Seguro que deseas quitar el transporte a este estudiante?")) return;
            const month = new Date().getMonth() + 1;
            if (configId) {
              updateConfig({ id: configId, transport_payment_value: 0 });
            } else {
              createConfig({ transport_payment_value: 0, student_id: id, year, month });
            }
            fetch(`/api/student/${id}/remove-transport`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ year, month }),
            }).catch(() => { });
            reset((prev) => ({ ...prev, transport_payment_value: 0 }));
          }}
        >
          Quitar transporte
        </button>
      </div>
    </form>
  );
};

export default StudentConfig;
